<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div [formGroup]="parentFormGroup" class="properties-component">
  <label *ngIf="!title">{{ 'PROPERTY_COMPONENT.PROPERTIES' | translate }}</label>
  <label *ngIf="title">{{ title }}</label>
  <div formArrayName="properties" class="row">
    <div
      *ngFor="let property of parentFormGroup.get('properties')?.controls; let M = index"
      class="single-property col-sm-4"
    >
      <button
        type="button"
        class="remove-property"
        (click)="removeProperty(M)"
        *ngIf="parentFormGroup.get('properties').controls.length > 1"
      >
        <i class="fal fa-times"></i>
      </button>
      <div [formGroupName]="M">
        <div class="row g-0">
          <div class="col-sm-4">
            <div class="form-group">
              <app-type-select
                [parentFormGroup]="property"
                [groupType]="'supplier_properties'"
                [passFormControlName]="'type_id'"
                class="property-type-select"
              ></app-type-select>
            </div>
          </div>
          <div class="col-sm-8">
            <div class="form-group">
              <input type="email" class="form-control form-control-property-value" formControlName="value" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-4">
      <button type="button" class="btn btn-input btn-outline-primary mb-2" (click)="addProperty()">
        {{ 'PROPERTY_COMPONENT.ADD_PROPERTY' | translate }}
      </button>
    </div>
  </div>
</div>
